import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: any = '';

export const currentTerritoryFilterSlice = createSlice({
  name: 'currentTerritoryFilter',
  initialState,
  reducers: {
    currentTerritoryFilter: (state, action: PayloadAction<any>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { currentTerritoryFilter } = currentTerritoryFilterSlice.actions;

export default currentTerritoryFilterSlice.reducer;
